import { Routes } from "react-router-dom";
import publicRoutes from "./PublicRoutes";
import protectedRoutes from "./ProtectedRoutes";

const AppRoutes = () => {
  return (
    <Routes>
      {publicRoutes}
      {protectedRoutes}
    </Routes>
  );
};

export default AppRoutes;
